export const dummyQuestions = [
  {
    question: 'It lays eggs',
    answer: 'HEN',
  },
  {
    question: 'What is the Capital City of Spain?',
    answer: 'MADRID',
  },
  {
    question: 'What is 99 + 2578301?',
    answer: '2578400',
  },
  {
    question: 'YOU COMPLETED THE TEST - WELL DONE!!',
    answer: '',
  },
]

export const dummyLetters = [
  [
    {
      id: 1,
      locked: false,
      letter: 'N',
      top: 90,
      startPos: 1 * 80,
      endPos: 0,
    },
    {
      id: 2,
      letter: 'H',
      locked: false,
      top: 90,
      startPos: 2 * 80,
      endPos: 0,
    },
    {
      id: 3,
      letter: 'E',
      locked: false,
      top: 90,
      startPos: 3 * 80,
      endPos: 0,
    },
  ],
  [
    {
      id: 1,
      locked: false,
      letter: 'R',
      top: 90,
      startPos: 1 * 80,
      endPos: 0,
    },
    {
      id: 2,
      letter: 'I',
      locked: false,
      top: 90,
      startPos: 2 * 80,
      endPos: 0,
    },
    {
      id: 3,
      letter: 'M',
      locked: false,
      top: 90,
      startPos: 3 * 80,
      endPos: 0,
    },
    {
      id: 4,
      letter: 'D',
      locked: false,
      top: 90,
      startPos: 4 * 80,
      endPos: 0,
    },
    {
      id: 5,
      letter: 'A',
      locked: false,
      top: 90,
      startPos: 5 * 80,
      endPos: 0,
    },
    {
      id: 6,
      letter: 'D',
      locked: false,
      top: 90,
      startPos: 6 * 80,
      endPos: 0,
    },
  ],

  [
    {
      id: 1,
      locked: false,
      letter: '8',
      top: 90,
      startPos: 1 * 80,
      endPos: 0,
    },
    {
      id: 2,
      letter: '0',
      locked: false,
      top: 90,
      startPos: 2 * 80,
      endPos: 0,
    },
    {
      id: 3,
      letter: '7',
      locked: false,
      top: 90,
      startPos: 3 * 80,
      endPos: 0,
    },
    {
      id: 4,
      letter: '0',
      locked: false,
      top: 90,
      startPos: 4 * 80,
      endPos: 0,
    },
    {
      id: 5,
      letter: '4',
      locked: false,
      top: 90,
      startPos: 5 * 80,
      endPos: 0,
    },
    {
      id: 6,
      letter: '2',
      locked: false,
      top: 90,
      startPos: 6 * 80,
      endPos: 0,
    },
    {
      id: 7,
      letter: '5',
      locked: false,
      top: 90,
      startPos: 7 * 80,
      endPos: 0,
    },
  ],
  [],
]
